import _ from 'lodash';
import React, { useState } from 'react';

import AppBar from '@mui/material/AppBar';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import { makeStyles } from '@mui/styles';

import OwnOrganizationDashboard from './own-organization';
import ChildOrganizationDashboard from './child-organization';
import { can } from 'services/can';

const tabs = [
    {
        label: 'Manage Organization',
        value: 'own',
        // admin_org__view — product/tab gate; urban ownOrganization GraphQL has no @authorize.
        intent: 'admin_org__view',
    },
    {
        label: 'Manage Sub-Organizations',
        value: 'children',
        // admin_subOrg__view — urban GraphQL organizations + REST GET /organizations (subOrgsViewMw).
        intent: 'admin_subOrg__view',
    },
];

const adminStyles = makeStyles(theme => ({
    marginBottom: {
        marginBottom: theme.spacing(2),
    },
    adminRoot: {
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        minHeight: 0,
        overflow: 'hidden',
    },
    dashboardContainer: {
        padding: theme.spacing(3),
        flex: 1,
        minHeight: 0,
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',
    },
    dashboardBody: {
        flex: 1,
        minHeight: 0,
        overflow: 'hidden',
    },
}));

const Admin = () => {
    const [currentTab, setCurrentTab] = useState('own');
    const classes = adminStyles();
    const onChangeTab = (event, value) => {
        setCurrentTab(value);
    };
    return (
        <div className={classes.adminRoot}>
            <AppBar position="static" color="inherit" elevation={1}>
                <Tabs
                    value={currentTab}
                    onChange={onChangeTab}
                    indicatorColor="primary"
                    textColor="primary"
                >
                    {_.map(tabs, tab => {
                        return can(tab.intent) ? (
                            <Tab key={tab.value} label={tab.label} value={tab.value} />
                        ) : null;
                    })}
                </Tabs>
            </AppBar>
            <div className={classes.dashboardContainer}>
                <div className={classes.dashboardBody}>
                    {currentTab === 'own' ? (
                        <OwnOrganizationDashboard />
                    ) : (
                        <ChildOrganizationDashboard />
                    )}
                </div>
            </div>
        </div>
    );
};

export default Admin;
